// src/pages/micuenta/MiCuentaEmpleadorMenu.jsx
import { Link } from "react-router-dom";
import {
  FaUser,
  FaLock,
  FaCreditCard,
  FaFileInvoiceDollar,
  FaBell,
  FaPlusCircle,
  FaBriefcase,
  FaUsers,
  FaChevronRight,
} from "react-icons/fa";
import "./micuentausuarioempleador.css";

function MiCuentaEmpleadorMenu() {
  return (
    <>
      <h1 className="account-title">
        MI CUENTA <span className="account-subtitle">(Empleador)</span>
      </h1>

      {/* Grupo: Empleo */}
      <div className="account-group">
        <h2 className="group-title">Empleo</h2>
        <Link to="/mi-cuenta/publicar-empleo" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaPlusCircle className="button-icon" />
              <span className="button-text">Publicar Empleo</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/empleos-publicados" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaBriefcase className="button-icon" />
              <span className="button-text">Empleos Publicados</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/candidatos" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaUsers className="button-icon" />
              <span className="button-text">Candidatos</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>

      {/* Grupo: Suscripción */}
      <div className="account-group">
        <h2 className="group-title">Suscripción</h2>
        <Link to="/mi-cuenta/suscripciones" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaBell className="button-icon" />
              <span className="button-text">Suscripción</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>

      {/* Grupo: Maneja tu cuenta */}
      <div className="account-group">
        <h2 className="group-title">Maneja tu cuenta</h2>
        <Link to="/mi-cuenta/datos-personales" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaUser className="button-icon" />
              <span className="button-text">Datos personales</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/configuracion-seguridad" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaLock className="button-icon" />
              <span className="button-text">Configuración de seguridad</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>

      {/* Grupo: Información de Pago */}
      <div className="account-group">
        <h2 className="group-title">Información de Pago</h2>
        <Link to="/mi-cuenta/metodos-pago" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaCreditCard className="button-icon" />
              <span className="button-text">Métodos de Pago</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/facturacion" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaFileInvoiceDollar className="button-icon" />
              <span className="button-text">Facturación</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}

export default MiCuentaEmpleadorMenu;